import { CardTokenResponse, GuestCardSummary, VaultedCard } from '@core/models';
import { createReducer, on } from '@ngrx/store';
import { IResponseBadRequest } from '@core/interfaces';
import { 
  CREATE_VAULTED_CARD, CREATE_VAULTED_CARD_FAILURE, CREATE_VAULTED_CARD_SUCCESS, DELETE_VAULTED_CARD, DELETE_VAULTED_CARD_FAILURE, DELETE_VAULTED_CARD_SUCCESS, FIND_VAULTED_CARD_BY_ID, FIND_VAULTED_CARD_BY_ID_FAILURE, FIND_VAULTED_CARD_BY_ID_SUCCESS, FIND_VAULTED_CARDS, FIND_VAULTED_CARDS_FAILURE, FIND_VAULTED_CARDS_SUCCESS, SET_DEFAULT_VAULTED_CARD, SET_DEFAULT_VAULTED_CARD_FAILURE, SET_DEFAULT_VAULTED_CARD_SUCCESS, VAULTED_CARDS_UPDATE_LOADING,
  CLEAR_VAULTED_CARDS_STATE, CLEAR_TOKEN_ASSOCIATED_CARD, CREATE_TOKEN_ASSOCIATED_CARD, CREATE_TOKEN_ASSOCIATED_CARD_FAILURE, CREATE_TOKEN_ASSOCIATED_CARD_SUCCESS, SET_SELECTED_VAULTED_CARD
 } from '@store/actions';

export interface CreditCardVaultState {
  cards: VaultedCard[];
  selectedCard: VaultedCard | null;
  defaultCard: VaultedCard | null;
  loading: boolean;
  loaded: boolean;
  error: IResponseBadRequest | null;
  creating: boolean;
  deleting: boolean;
  updating: boolean;
  tokenAssociatedCard: CardTokenResponse | null;
  guestCardSummary: GuestCardSummary | null;
  customerLoading: boolean;
  customerError: IResponseBadRequest | null;
}

export const initialState: CreditCardVaultState = {
  cards: [],
  selectedCard: null,
  defaultCard: null,
  loading: false,
  loaded: false,
  error: null,
  creating: false,
  deleting: false,
  updating: false,
  tokenAssociatedCard: null,
  guestCardSummary: null,
  customerLoading: false,
  customerError: null,
};

export const creditCardVaultReducer = createReducer(
  initialState,
  on(VAULTED_CARDS_UPDATE_LOADING,(state, { loading }) => ({...state, loading})),
  // Cargar todas las tarjetas
  on(FIND_VAULTED_CARDS, (state) => ({
    ...state,
    error: null,
  })),
  on(FIND_VAULTED_CARDS_SUCCESS,(state, { response }) => ({...state,cards: response.data, loaded: true})),
  on(FIND_VAULTED_CARDS_FAILURE, (state, { error }) => ({
    ...state,
    error,
  })),

  // Cargar tarjeta por ID
  on(FIND_VAULTED_CARD_BY_ID, (state) => ({
    ...state,
    error: null,
  })),
  on(
    FIND_VAULTED_CARD_BY_ID_SUCCESS,
    (state, { card }) => ({
      ...state,
      selectedCard: card,
    })
  ),
  on(
    FIND_VAULTED_CARD_BY_ID_FAILURE,
    (state, { error }) => ({
      ...state,
      error,
    })
  ),

  // Crear tarjeta
  on(CREATE_VAULTED_CARD, (state) => ({
    ...state,
    creating: true,
    error: null,
  })),
  on(CREATE_VAULTED_CARD_SUCCESS, (state, { card }) => {
    const exists = state.cards.some(c => c.idVaultedCard === card.idVaultedCard);
    const updatedCards = exists
      ? state.cards.map(c => c.idVaultedCard === card.idVaultedCard ? card : c)
      : [...state.cards, card];
    return {
      ...state,
      cards: updatedCards,
      selectedCard: card,
      creating: false,
    };
  }),
  on(
    CREATE_VAULTED_CARD_FAILURE,
    (state, { error }) => ({
      ...state,
      creating: false,
      error,
    })
  ),

  // Eliminar tarjeta
  on(DELETE_VAULTED_CARD, (state) => ({
    ...state,
    deleting: true,
    error: null,
  })),
  on(DELETE_VAULTED_CARD_SUCCESS, (state, { id }) => ({
    ...state,
    cards: state.cards.filter((card) => card.idVaultedCard !== id),
    deleting: false,
  })),
  on(
    DELETE_VAULTED_CARD_FAILURE,
    (state, { error }) => ({
      ...state,
      deleting: false,
      error,
    })
  ),
  // Establecer tarjeta como predeterminada
  on(SET_DEFAULT_VAULTED_CARD, (state) => ({
    ...state,
    updating: true,
    error: null,
  })),
  on(
    SET_DEFAULT_VAULTED_CARD_SUCCESS,
    (state, { idVaultedCard, isDefault }) => ({
      ...state,
      cards: state.cards.map((card) => ({
        ...card,
        default: card.idVaultedCard === idVaultedCard ? isDefault : false,
      })),
      updating: false,
    })
  ),
  on(
    SET_DEFAULT_VAULTED_CARD_FAILURE,
    (state, { error }) => ({
      ...state,
      updating: false,
      error,
    })
  ),

  // Establecer tarjeta seleccionada
  on(SET_SELECTED_VAULTED_CARD, (state, { card }) => ({
    ...state,
    selectedCard: card,
  })),

  on(CREATE_TOKEN_ASSOCIATED_CARD, (state) => ({
    ...state,
    customerError: null,
  })),
  on(
    CREATE_TOKEN_ASSOCIATED_CARD_FAILURE,
    (state, { error }) => ({
      ...state,
      customerError: error,
    })
  ),
  on(CREATE_TOKEN_ASSOCIATED_CARD_SUCCESS, (state, { response, cardSummary }) => ({
  ...state,
  tokenAssociatedCard: {
    id: response.id,
    cardAccount: {
      token: response.cardAccount.token,
      hasContract: response.cardAccount.hasContract
    }
  },
  guestCardSummary: cardSummary ?? state.guestCardSummary,
  customerLoading: false
})),

  on(CLEAR_TOKEN_ASSOCIATED_CARD, (state) => ({
    ...state,
    tokenAssociatedCard: null,
    guestCardSummary: null,
  })),

  // Limpiar estado
  on(CLEAR_VAULTED_CARDS_STATE, () => initialState)
);
